import { makeFupIcon } from './FupIconFactory';
export default makeFupIcon('HYST');
